<p-card class="kpi-card" [class]="'kpi-card--' + color()">
  <!-- Loading State -->
  @if (loading()) {
    <ng-template pTemplate="header">
      <div class="kpi-card__header">
        <div class="skeleton-circle"></div>
        <div class="skeleton-text skeleton-title"></div>
      </div>
    </ng-template>
    <div class="kpi-card__content">
      <div class="skeleton-text skeleton-value"></div>
    </div>
  }

  <!-- Loaded State -->
  @if (!loading()) {
    <ng-template pTemplate="header">
      <div class="kpi-card__header">
        <i class="kpi-card__icon" [class]="icon()"></i>
        <h3 class="kpi-card__title">{{ title() }}</h3>
      </div>
    </ng-template>
    <div class="kpi-card__content">
      <div class="kpi-card__value">{{ value()?.toLocaleString() ?? '0' }}</div>
    </div>
    @if (ctaLabel()) {
      <ng-template pTemplate="footer">
        <div class="kpi-card__footer">
          <p-button
            severity="primary"
            size="large"
            variant="text"
            [label]="ctaLabel()"
            [icon]="ctaIcon()"
            (onClick)="ctaClick.emit()"
          ></p-button>
        </div>
      </ng-template>
    }
  }
</p-card>
